<template>
  <div class="card-content filterContainer">
    <b-field>
      <b-input
        :value="searchQuery"
        :placeholder="$t('items.searchPlaceholder')"
        type="search"
        ref="search"
        icon-pack="fas"
        icon="search"
        icon-right="close-circle"
        icon-right-clickable
        @icon-right-click="clearSearch"
        @keyup.enter.native="triggerSearch"
      >
      </b-input>
    </b-field>

    <div class="divider is-left">{{ $t("items.category") }}</div>

    <div v-if="isLoading && mainCategories.length == 0">
      <div v-for="index in 6" :key="index" style="margin-bottom: 12px;">
        <b-skeleton
          size="is-large"
          width="100%"
          height="40px"
          :active="isLoading"
        ></b-skeleton>
      </div>
    </div>

    <div v-if="!isLoading && mainCategories.length == 0">
      <b-message type="is-warning">{{
        $t("items.tryToChangeQuery")
      }}</b-message>
    </div>

    <div v-if="mainCategories.length > 0">
      <div
        class="field"
        v-for="(category, categoryIndex) in mainCategories"
        :key="`mainCategory-${category.value}`"
      >
        <b-checkbox
          :value="isCategoryActive(categoryIndex) ? true : false"
          @input="selectMainCategory(categoryIndex)"
          >{{ $t(`items.categories.${category.value}`) }}</b-checkbox
        >
        <div v-if="isCategoryActive(categoryIndex)">
          <div v-if="subCategories?.length > 0">
            <div
              class="pl-4"
              v-for="(subCategory, subCategoryIndex) in subCategories"
              :key="`subCategory-${subCategory.value}`"
            >
              <b-checkbox
                v-if="subCategory.value"
                style="margin-top: 5px; margin-bottom: 5px;"
                :value="isSubCategoryActive(subCategoryIndex) ? true : false"
                @input="selectSubCategory(subCategoryIndex)"
                >{{
                  $t(`items.subCategories.${subCategory.value}`)
                }}</b-checkbox
              >
            </div>
          </div>
          <div v-else>
            <b-skeleton
              size="is-large"
              width="100%"
              height="30px"
              :active="isLoading"
            ></b-skeleton>
          </div>
        </div>
      </div>
      <div class="facets" v-if="showFacets">
        <div
          class="field"
          v-for="facet in facets"
          :key="`facet-${facet.field_name}`"
        >
          <div class="divider is-left" v-if="facet.counts.length >= 1">
            {{ $t(`items.${facet.field_name}`) }}
          </div>

          <div
            v-for="facetCount in facet.counts"
            :key="`facetCount-${facet.field_name}-${facetCount.value}`"
          >
            <b-checkbox
              v-model="selectedFacets"
              :native-value="{
                facet: facet.field_name,
                facetCountValue: facetCount.value
              }"
              @input="updateItems(true)"
              >{{
                isTranslatedFacet(facet.field_name)
                  ? $t(`items.${facetCount.value}`)
                  : facetCount.value
              }}
              ({{ facetCount.count }})</b-checkbox
            >
          </div>
        </div>

        <!-- 
        <div class="divider is-left">
          {{ $t(`items.year`) }}
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Fra">
              <b-input v-model="fromYear"></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Til">
              <b-input v-model="toYear"></b-input>
            </b-field>
          </div>
          <div class="column" style="margin-top: 32px">
            <p class="control">
              <b-button class="button is-primary">+</b-button>
            </p>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "isLoading",
    "facets",
    "showFacets",
    "mainCategories",
    "subCategories",
    "isTranslatedFacet",
    "isCategoryActive",
    "isSubCategoryActive",
    "searchQuery",
    "selectedParentFacets"
  ],

  data() {
    return {
      selectedFacets: [],
      facetCount: [],
      fromYear: null,
      toYear: null
    };
  },

  methods: {
    updateItems(updateRouter) {
      this.$emit("updateFacets", this.selectedFacets);
      this.$emit("updateItems", updateRouter);
    },
    selectMainCategory(index) {
      this.$emit("selectMainCategory", index);
    },
    selectSubCategory(index) {
      this.$emit("selectSubCategory", index);
    },

    clearSearch() {
      if (this.$refs.search.newValue) {
        this.$refs.search.newValue = "";
        this.$emit("updateSearchQuery", "");
        this.$emit("clearSearch");
      }
    },
    triggerSearch(event) {
      this.$emit("updateSearchQuery", this.$refs.search.newValue);
      this.$emit("triggerSearch", event);
    },
    updateSearchQuery(val) {
      this.$emit("updateSearchQuery", val);
    },

    updateParams() {
      if (this.$route.query.q) this.updateSearchQuery(this.$route.query.q);
      if (this.$route.query.filter_by) {
        const filterByParams = this.$route.query.filter_by.split("::");

        window._.each(filterByParams, paramsArray => {
          const params = paramsArray.split(":");
          const key = params[0];
          const value = params[1].split(",");

          if (key == "category") {
            this.$emit("setSelectedMainCategory", value[0]);
            //this.selectedMainCategory = value[0];
          } else if (key == "subCategory") {
            this.$emit("setSelectedSubCategory", value[0]);
            //this.selectedSubCategory = value[0];
          } else {
            window._.each(value, valueArray => {
              this.selectedFacets.push({
                facet: key,
                facetCountValue: valueArray
              });
            });
          }
        });
      }
      if (this.$route.query.page) this.page = this.$route.query.page;
      if (this.$route.query.per_page)
        this.per_page = this.$route.query.per_page;
      if (this.$route.query.sortBy)
        this.selectedSortBy = this.$route.query.sortBy;
    }
  },

  mounted() {
    if (this.$route.query.q) this.updateSearchQuery(this.$route.query.q);
    if (this.$route.query.filter_by) {
      const filterByParams = this.$route.query.filter_by.split("::");
      window._.each(filterByParams, paramsArray => {
        const params = paramsArray.split(":");
        const key = params[0];
        const value = params[1].split(",");

        if (key == "category") {
          this.$emit("setSelectedMainCategory", value[0]);
          //this.selectedMainCategory = value[0];
        } else if (key == "subCategory") {
          this.$emit("setSelectedSubCategory", value[0]);
          //this.selectedSubCategory = value[0];
        } else {
          window._.each(value, valueArray => {
            this.selectedFacets.push({
              facet: key,
              facetCountValue: valueArray
            });
          });
        }
      });
    }
    if (this.$route.query.page) this.page = this.$route.query.page;
    if (this.$route.query.per_page) this.per_page = this.$route.query.per_page;
    if (this.$route.query.sortBy)
      this.selectedSortBy = this.$route.query.sortBy;

    //this.updateItems(false);
  },
  watch: {
    selectedParentFacets: function(newval) {
      this.selectedFacets = newval;
    }
  }
};
</script>

<style lang="scss" scoped></style>
